/**
 * Client-side configuration and presentation constants. Game rules live in the
 * core; this is purely about how the app is set up and themed.
 */
import type { BoardConfig, PlayerId } from "../core";

export interface SessionSettings {
  /** Show a "pass the device" curtain between turns to keep hands secret. */
  readonly hideHandsBetweenTurns: boolean;
}

export const DEFAULT_SETTINGS: SessionSettings = {
  hideHandsBetweenTurns: true,
};

export const PLAYER_NAMES: Readonly<Record<PlayerId, string>> = {
  0: "Player 1",
  1: "Player 2",
};

/** Per-seat accent colours used across the board and UI chrome. */
export const PLAYER_COLORS: Readonly<Record<PlayerId, string>> = {
  0: "#e9e2c8", // warm ivory (light pieces)
  1: "#2b2f3a", // slate (dark pieces)
};

export const PLAYER_ACCENT: Readonly<Record<PlayerId, string>> = {
  0: "#d98a3d", // amber
  1: "#5b9bd5", // blue
};

export function describeBudget(cfg: BoardConfig): string {
  return `${cfg.budget} points · ${cfg.openingHand}-card opening hand · hand limit ${cfg.handLimit}`;
}
